module.exports = __webpack_public_path__ + "static/orwells-revenge-d3d919c04b55f8e7d8b2a869e72451fc.jpg";